// @ts-nocheck
import { IconOffset, IconDefinitionProps } from "@toolkit/Framework/Types/Icon";
import React, { FC, memo } from "react";
import parseIconDefinitionProps from "@toolkit/Framework/Common/Utilities/parseIconDefinitionProps";

const PinLine: FC<IconDefinitionProps> = props => {
    const { size, color } = parseIconDefinitionProps(props);

    return (
        /* Store Custom Code - Start */
        <svg
            focusable="false"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            width={size}
            height={size}
        >
            <path
                fill={color}
                d="M12.004 11.73c.445 0 .825-.158 1.14-.475.315-.317.472-.698.472-1.143 0-.445-.159-.825-.476-1.14a1.565 1.565 0 0 0-1.143-.472c-.445 0-.825.159-1.14.476a1.564 1.564 0 0 0-.472 1.143c0 .445.159.825.476 1.14.317.314.698.472 1.143.472Zm-.003 7.947c1.879-1.636 3.365-3.3 4.457-4.992 1.093-1.691 1.639-3.154 1.639-4.389 0-1.83-.58-3.34-1.738-4.53-1.158-1.19-2.611-1.785-4.359-1.785-1.747 0-3.2.595-4.358 1.785-1.159 1.19-1.738 2.7-1.738 4.53 0 1.235.546 2.698 1.639 4.39C8.635 16.377 10.12 18.04 12 19.676Zm0 1.342c-2.35-2.078-4.12-4.016-5.31-5.814-1.191-1.798-1.787-3.434-1.787-4.909 0-2.115.69-3.86 2.067-5.234C8.348 3.686 10.025 3 12 3c1.975 0 3.652.687 5.03 2.061 1.377 1.375 2.066 3.12 2.066 5.235 0 1.475-.596 3.11-1.786 4.909-1.19 1.798-2.96 3.736-5.31 5.814Z"
            />
        </svg>
        /* Store Custom Code - End */
    );
};

export const PinLineOffset: IconOffset = {
    vertical: 12, // Store Custom Code
    horizontal: 20, // Store Custom Code
};

export default memo(PinLine);
